// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__SQpP5","slash":"styles_slash__xebFj","dark":"styles_dark__fZIOc"};